import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from "@angular/material/autocomplete";
import {MatFormField, MatInput} from "@angular/material/input";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {map, Observable, startWith} from "rxjs";
import {Article} from "../../../model/article";
import {getFieldByKey} from "../../../functions/getObj";

@Component({
  selector: 'app-autocomplete-input',
  imports: [

    ReactiveFormsModule,
    NgForOf,
    FormsModule,
    NgIf,
  ],
  templateUrl: './autocomplete-input.component.html',
  styleUrl: './autocomplete-input.component.scss'
})
export class AutocompleteInputComponent  {
  @Input() options: any[] = [];
  @Input() key: string = '';
  @Input() searchTerm: string = '';
  @Output() emitItem = new EventEmitter();
  isOpen: boolean = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Проверяем, что клик не внутри компонента
    if (!target.closest('.dropdown-container')) {
      this.close()
    }
  }

  filteredItems() {
    if (!this.searchTerm) {
      return this.options;
    }
    const term = this.searchTerm.toLowerCase();
    return this.options.filter(item => this.getField(item, this.key).toLowerCase().includes(term));
  }

  // Открываем список при фокусе или вводе
  open() {
    this.isOpen = true;
  }

  // Закрываем список
  close() {
    setTimeout(() => {
      this.isOpen = false;
    }, 10);
  }

  getField(item: any, key: string) {
    return getFieldByKey(item, key);
  }

  selectItem(item: any) {
    this.searchTerm = this.getField(item, this.key);
    this.emitItem.emit(item);
    this.close();
  }

  clearSearch(event: MouseEvent) {
    event.stopPropagation(); // чтобы клик не закрывал список или не срабатывал лишний раз
    this.searchTerm = '';
    this.emitItem.emit(null);
  }

}
